export { default as TagOutlineIcon } from './TagOutlineIcon';
